import { SalesAppState } from "../SalesAppDataStore";
import { DefaultSale, Sale } from "./SaleData";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from 'react-redux';

export type SaleData = {
    currentSale: Sale,
};

/// Sale Data Slice

const DefaultSaleSalesData: SaleData = {
    currentSale: DefaultSale,
};

export const salesDataSlice = createSlice({
    name: 'Sales',
    initialState: DefaultSaleSalesData,
    reducers: {
        setCurrentSale: (state, action: PayloadAction<Sale>) => {            
            return {
                currentSale: { ...action.payload }
            }
        }
    }
});

export const useCurrentSale = () => {
    return useSelector((state: SalesAppState) => state.sales.currentSale);
}

export default salesDataSlice.reducer;